// removed by extract-text-webpack-plugin
module.exports = {"no-results":"no-documents__no-results___3HUoP","blank-slate":"no-documents__blank-slate___KDI3e","no-pending":"no-documents__no-pending___1qcV6"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/no-documents.scss
// module id = 514
// module chunks = 0